import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class PassportButtonModel extends ButtonBase {
    label: string = 'Passport';
    action: string = ACTION_STATUS.passport;
    matIconName: string = 'assignment_ind';
    colorClass: string = 'color-secondary-500';
}